jQuery(document).ready(function($) {
  $('.slick.marquee').slick({
    speed: 5000,
    autoplay: true,
    autoplaySpeed: 0,
    centerMode: true,
    cssEase: 'linear',
    slidesToShow: 1,
    slidesToScroll: 1,
    variableWidth: true,
    infinite: true,
    initialSlide: 1,
    arrows: false,
      pauseOnFocus: false, 
  pauseOnHover: false,
    draggable: false,
    buttons: false
  });


  
    $('.marquee_col_main').slick({
    speed: 5000,
    autoplay: true,
    autoplaySpeed: 0,
    centerMode: true,
    cssEase: 'linear',
    slidesToShow: 1,
    slidesToScroll: 1,
    variableWidth: true,
    infinite: true,
    initialSlide: 1,
    arrows: false,
    buttons: false,
    pauseOnFocus: false, 
  pauseOnHover: false,
    draggable: false,
    responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1
      }
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1
      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1
      }
    }
  ]
  });

    $('.testi_outer').slick({
     infinite: true,
    slidesToShow: 3,
    slidesToScroll: 1,
    arrows: false,
    buttons: false, 
      responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1
      }
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1
      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1
      }
    }
  ]
  });
       $('.custom_list_wrap2').slick({
     slidesToShow: 2,
     slidesToScroll: 1,
     infinite: false,
     arrows: true,
     mobileFirst: true,
     responsive: [
        {
           breakpoint: 750,
           settings: "unslick"
        }
     ]
  });
$('.custom_list_wrap1').slick({
     slidesToShow: 2,
     slidesToScroll: 1,
     infinite: false,
     arrows: true,
     mobileFirst: true,
     responsive: [
        {
           breakpoint: 750,
           settings: "unslick"
        }
     ]
  });

  $('.custom_list_wrap3').slick({
     slidesToShow: 2,
     slidesToScroll: 1,
     infinite: false,
     arrows: true,
     mobileFirst: true,
  accessibility: false,
     responsive: [
        {
           breakpoint: 750,
           settings: "unslick"
        }
     ]
  });
  $('.custom_list_wrap4').slick({
     slidesToShow: 2,
     slidesToScroll: 1,
     infinite: false,
     arrows: true,
     mobileFirst: true,
  accessibility: false,
     responsive: [
        {
           breakpoint: 750,
           settings: "unslick"
        }
     ]
  });
  $('.custom_list_wrap5').slick({
     slidesToShow: 2,
     slidesToScroll: 1,
     infinite: false,
     arrows: true,
     mobileFirst: true,
  accessibility: false,
     responsive: [
        {
           breakpoint: 750,
           settings: "unslick"
        }
     ]
  });
});

